/* eslint-disable max-lines */

import { Box, Button, Dialog as ChamDialog, Divider, Heading } from '@mediahuis/chameleon-react'
import React, { useState } from 'react'
import styled from 'styled-components'

import { Purpose } from '../../../../api/AccountConsent/getPurposeCopy'
import { Content, accept as acceptText, decline as declineText } from './Content'

type DialogType = {
  purpose: Purpose
  accept: () => void
  decline: () => void
}

export const Dialog: React.FC<DialogType> = ({ purpose, accept, decline }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(true)

  const handleAccept = (e: React.MouseEvent) => {
    e.preventDefault()
    accept()
    setIsDialogOpen(false)
  }

  const handleDecline = (e: React.MouseEvent) => {
    e.preventDefault()
    decline()
    setIsDialogOpen(false)
  }

  return (
    <ChamDialog
      closeOnBackdropClick={false}
      closeOnEscape={false}
      headerHidden
      lockBodyOnScroll={false}
      show={isDialogOpen}
    >
      {MH_BRAND_GROUP === 'mhbe' && (
        <Box mb={2}>
          <img
            alt="Logo mh"
            height="20px"
            width="110px"
            src="https://focus.mediahuisgroup.com/raw/prod-mh-design-system/5.7.0/mh/logos/brand-main.svg"
          />
        </Box>
      )}

      {purpose.titleImageUrl ? (
        <ImageHeader>
          <HeaderImg alt={purpose.title} src={purpose.titleImageUrl} />
        </ImageHeader>
      ) : (
        <Header>
          <StyledHeading>{purpose.title}</StyledHeading>
        </Header>
      )}

      <ContentWrapper>
        <Content html={String(purpose.html)} />
      </ContentWrapper>

      <Divider />

      <Footer>
        {MH_BRAND_GROUP === 'mhbe' ? (
          <>
            <ButtonPrimary onClick={handleAccept}>{acceptText}</ButtonPrimary>
            <ButtonSecondary onClick={handleDecline}>{declineText}</ButtonSecondary>
          </>
        ) : (
          <>
            <Button appearance="primary" width="full" onClick={handleAccept}>
              {acceptText}
            </Button>
            <Button appearance="plain" width="full" onClick={handleDecline}>
              {declineText}
            </Button>
          </>
        )}
      </Footer>
    </ChamDialog>
  )
}

const ImageHeader = styled.div`
  display: flex;
  height: 135px;
  justify-content: center;
`

const HeaderImg = styled.img`
  object-fit: scale-down;
  object-position: center;
`

const Header = styled.div`
  padding: 0;
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
`

const StyledHeading = styled(Heading)`
  font-size: 1.5rem !important;
  font-weight: 500;
`

const ContentWrapper = styled.div`
  ${MH_BRAND_GROUP === 'mhbe' && 'a { color: black !important; text-decoration: underline !important; }'}
  p,
  ul,
  ol {
    font-weight: 300;
    margin-bottom: 1rem;
    strong {
      font-weight: bold;
    }
  }
  p,
  li {
    font-family: 'Roboto', sans-serif;
  }
  p {
    line-height: 1.8;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 0;
`

const ButtonPrimary = styled(Button)`
  background-color: #030712 !important;
  color: white !important;
  font-family: 'Roboto', sans-serif !important;
  &:hover {
    background-color: #1f2937 !important;
    color: white !important;
  }
`

const ButtonSecondary = styled(Button)`
  background-color: #f3f4f6 !important;
  color: black !important;
  font-family: 'Roboto', sans-serif !important;
  &:hover {
    background-color: #d1d5db !important;
    color black !important;
  }
`
